import { render, staticRenderFns } from "./customerdistribution.vue?vue&type=template&id=35595174"
import script from "./customerdistribution.vue?vue&type=script&lang=js"
export * from "./customerdistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports